import { render, staticRenderFns } from "./IrCurrency.vue?vue&type=template&id=481f5b3c&scoped=true&"
import script from "./IrCurrency.vue?vue&type=script&lang=js&"
export * from "./IrCurrency.vue?vue&type=script&lang=js&"
import style0 from "./IrCurrency.vue?vue&type=style&index=0&id=481f5b3c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481f5b3c",
  null
  
)

export default component.exports